<h1 mat-dialog-title class="text-center pm-dialog-title">
    {{ isBatch ? ('Language.AutomaticBatchCreationText' | translate) : ('Language.AutomaticSerialCreationText' | translate)}}
</h1>
<div mat-dialog-content class="content">
    <div class="row mb-2">
        <div class="col-4">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <input type="text" matInput name="ItemCode" disabled="true"
                [ngModel]="this.local_data.itemCode" readonly="true" 
                placeholder="Item Code">
            </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <input type="text" matInput name="itemDescription" disabled="true"
                [ngModel]="this.local_data.itemDescription" readonly="true" 
                placeholder="Item Description">
            </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <input type="text" matInput name="warehouse" disabled="true"
                [ngModel]="this.local_data.warehouseName" readonly="true"
                placeholder="Warehouse Name">
            </mat-form-field>
        </div>
    </div>

    <div class="row" *ngIf="isBatch">
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.QuantityBatchText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput disabled="true"
                        [ngModel]="this.local_data.quantity"
                        name="quantity" placeholder="Quantity">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.NoofBatchesText'| translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput 
                        name="noOfBatches" 
                        [(ngModel)]="batchItem.numOfBatch"
                        placeholder="No of Batches">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.BatchText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput 
                        name="batch"
                        [(ngModel)]="batchItem.batchNumber"
                        placeholder="Batch">
                        <mat-icon matSuffix (click)="showAutoStringPopup('Batch', 0)">queue</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.BatchAtt1Text'| translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput 
                        name="batchAttribute1" 
                        [(ngModel)]="batchItem.internalSerialNumber"
                        placeholder="Batch Attribute 1">
                        <mat-icon matSuffix (click)="showAutoStringPopup('Batch Attribute 1', 1)">queue</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.BatchAtt2Text'| translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput 
                        name="batchAttribute2"
                        [(ngModel)]="batchItem.manufacturerSerialNumber"
                        placeholder="Batch Attribute 2">
                        <mat-icon matSuffix (click)="showAutoStringPopup('Batch Attribute 2', 2)">queue</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.BinLocationText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput 
                        name="binLocation" readonly="true"
                        [(ngModel)]="batchItem.binLocationValue"
                        placeholder="Bin Location">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.AdmissionDate'| translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                        <input [matDatepicker]="AddmisionDate" required type="text"
                            [(ngModel)]="batchItem.addmisionDate"
                            matInput readonly (click)="AddmisionDate.open()" name="AddmisionDate"
                            placeholder="Admission Date" />
                        <mat-datepicker-toggle matSuffix [for]="AddmisionDate">
                        </mat-datepicker-toggle>
                        <mat-datepicker #AddmisionDate>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.ManufacturingDateText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                        <input [matDatepicker]="ManufacturingDate" required type="text"
                            [(ngModel)]="batchItem.manufacturingDate"
                            matInput readonly (click)="ManufacturingDate.open()" name="ManufacturingDate"
                            placeholder="Manufacturing Date" />
                        <mat-datepicker-toggle matSuffix [for]="ManufacturingDate">
                        </mat-datepicker-toggle>
                        <mat-datepicker #ManufacturingDate>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.ExpirationDateText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                        <input [matDatepicker]="ExpiraitonDate" required type="text"
                            [(ngModel)]="batchItem.expiryDate"
                            matInput readonly (click)="ExpiraitonDate.open()" name="ExpiraitonDate"
                            placeholder="Admission Date" />
                        <mat-datepicker-toggle matSuffix [for]="ExpiraitonDate">
                        </mat-datepicker-toggle>
                        <mat-datepicker #ExpiraitonDate>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!isBatch">
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.QuantityBatchText'| translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput disabled="true"
                        [ngModel]="this.local_data.quantity"
                        name="quantity" placeholder="Quantity">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.ManufacturingSerialNoText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput 
                        name="batchAttribute2"
                        [(ngModel)]="serialItem.manufacturerSerialNumber"
                        placeholder="Mfr Serial No.">
                        <mat-icon matSuffix (click)="showAutoStringPopup('Mfr Serial No.', 0)">queue</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.SerialNoText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput 
                        name="batchAttribute1"
                        [(ngModel)]="serialItem.internalSerialNumber"
                        placeholder="Serial Number">
                        <mat-icon matSuffix (click)="showAutoStringPopup('Serial Number', 1)">queue</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.LotNumberText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                        <input type="text" matInput 
                        name="batch"
                        [(ngModel)]="serialItem.batchID"
                        placeholder="Lot Number">
                        <mat-icon matSuffix (click)="showAutoStringPopup('Lot Number', 2)">queue</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.AdmissionDateText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                        <input [matDatepicker]="ReceptionDate" required type="text"
                            [(ngModel)]="serialItem.receptionDate"
                            matInput readonly (click)="ReceptionDate.open()" name="AddmisionDate"
                            placeholder="Admission Date" />
                        <mat-datepicker-toggle matSuffix [for]="ReceptionDate">
                        </mat-datepicker-toggle>
                        <mat-datepicker #ReceptionDate>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.ManufacturingDateText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                        <input [matDatepicker]="ManufacturingDate" required type="text"
                            [(ngModel)]="serialItem.manufactureDate"
                            matInput readonly (click)="ManufacturingDate.open()" name="ManufacturingDate"
                            placeholder="Manufacturing Date" />
                        <mat-datepicker-toggle matSuffix [for]="ManufacturingDate">
                        </mat-datepicker-toggle>
                        <mat-datepicker #ManufacturingDate>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.ExpirationDateText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                        <input [matDatepicker]="ExpiraitonDate" required type="text"
                            [(ngModel)]="serialItem.expiryDate"
                            matInput readonly (click)="ExpiraitonDate.open()" name="ExpiraitonDate"
                            placeholder="Expiraiton Date" />
                        <mat-datepicker-toggle matSuffix [for]="ExpiraitonDate">
                        </mat-datepicker-toggle>
                        <mat-datepicker #ExpiraitonDate>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.MfrWarrantyStartText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                        <input [matDatepicker]="WarrantyStart" required type="text"
                            [(ngModel)]="serialItem.warrantyStart"
                            matInput readonly (click)="WarrantyStart.open()" name="WarrantyStart"
                            placeholder="Mfr Warranty Start" />
                        <mat-datepicker-toggle matSuffix [for]="WarrantyStart">
                        </mat-datepicker-toggle>
                        <mat-datepicker #WarrantyStart>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row align-items-center mb-2">
                <div class="col-4">
                    <label class="label">{{'Language.MfrWarrantyEndText' | translate}}</label>
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                        <input [matDatepicker]="WarrantyEnd" required type="text"
                            [(ngModel)]="serialItem.warrantyEnd"
                            matInput readonly (click)="WarrantyEnd.open()" name="WarrantyEnd"
                            placeholder="Mfr Warranty End" />
                        <mat-datepicker-toggle matSuffix [for]="WarrantyEnd">
                        </mat-datepicker-toggle>
                        <mat-datepicker #WarrantyEnd>
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onBatchSerialCreation()">{{'Language.CreateText' | translate}}  </button>
    <button mat-raised-button mat-dialog-close>{{'Language.CancelText' | translate}}  </button>
</div>